import { ConceptKey } from "../../../models/concept";

// コンセプトは順番を決めておく。上からtest1、test2、競合品、現行品
export const conceptNumber = {
	test1: 1,
	test2: 2,
	benchmark: 3,
	currentProduct: 4,
} as const satisfies { [key in ConceptKey]: number };

/**
 * Quotaのコード番号
 */
export const quotaCode = {
	test1: "A",
	test2: "B",
	category: "C",
	strategy: "D",
} as const;

/**
 * カウント用のコード番号
 */
export const countQuotaCode = {
	general: "X",
	category: "Y",
	strategy: "Z",
} as const;
